import React from 'react'

function Svg1(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.277 11.185c-.097-1.173.262-3.52 2.472-3.52s2.375-1.955 2.181-2.933"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M21.5 10.318a.867.867 0 11-1.734 0 .867.867 0 011.734 0zM20.612 16.84a.846.846 0 11-1.692 0 .846.846 0 011.692 0zM9.26 4.522a.867.867 0 11-1.733 0 .867.867 0 011.734 0zM17.154 3.358a1.394 1.394 0 11-2.788 0 1.394 1.394 0 012.788 0z"
        stroke="currentColor"
      />
      <path
        d="M15.76 13.734c.923-.727 3.253-1.744 5.198 0M10.854 9.543c.94-.702 2.526-2.69 1.345-5.02"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M5 13.832l7.25 4.373m-4.383 1.69l-4.302-2.592"
        stroke="currentColor"
      />
      <path
        d="M4.302 21.399c-1.07.439-2.14-.63-1.7-1.7l4.14-10.092a.977.977 0 011.595-.32l6.376 6.375a.977.977 0 01-.32 1.596l-10.091 4.14z"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Svg1
